module.exports = __webpack_public_path__ + "static/house--characters@3x.e67636cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/house--characters@3x.png
// module id = 1286
// module chunks = 35783957827783